import React, { lazy, Suspense } from "react";
import { useSportsData } from "../App";
import SearchForm from "../components/SearchForm";
import UpcomingOfferings from "../components/UpcomingOffering";
const AdventureCategories = lazy(() => import("../components/AdventureCategories"));
// LocationCards is rarely used on home page; keep static if needed or convert later
// import Blogs from "../components/Blogs";
const Testimonials = lazy(() => import("../components/Testimonials"));
const WhyUs = lazy(() => import("../components/WhyUs"));
const ScrollableLine = lazy(() => import("../components/ScrollableLine"));
const FilterByLocation = lazy(() => import("../components/FilterByLocation"));
const FAQSection = lazy(() => import("../components/FAQSection"));

const Home = () => {
  const { data: sports = [] } = useSportsData();
  return (
    <div className="bg-white pt-16 md:pt-0">
      <SearchForm sports={sports} />
      <Suspense fallback={null}><ScrollableLine/></Suspense>
      <UpcomingOfferings sports={sports} />
       <Suspense fallback={null}><AdventureCategories sports={sports} /></Suspense>  
      <Suspense fallback={null}><FilterByLocation/></Suspense>
      {/* <LocationCards sports={sports || []} /> */}
      <Suspense fallback={null}><WhyUs/></Suspense>
      {/* <Blogs/> */}
      <Suspense fallback={null}><Testimonials/></Suspense>
      <Suspense fallback={null}><FAQSection/></Suspense>
    </div>
  );
};

export default Home;